import { useEffect, useRef } from 'react'

const useAutoFocus = (inputRef, autoFocus, autoFocusDelay) => {
  const intervalCount = useRef(0)

  useEffect(() => {
    if (!autoFocus) {
      return
    }

    const interval = setInterval(() => {
      intervalCount.current = intervalCount.current + 1
      if (intervalCount.current > 10) {
        clearInterval(interval)
      }

      if (inputRef?.current) {
        clearInterval(interval)

        setTimeout(() => {
          const elementToFocus = inputRef?.current?.inputElement || inputRef?.current?.input || inputRef?.current
          if (elementToFocus?.focus) {
            elementToFocus.focus()
          }
        }, autoFocusDelay)
      }
    }, 100)

    return () => clearInterval(interval)
  }, [])
}

export default useAutoFocus
